<template>
  <nav aria-label="面包屑" class="pt-3">
    <ol class="breadcrumb mb-2">
      <li
        v-for="(item, index) in items"
        :key="item.path"
        class="breadcrumb-item"
        :class="{ active: index === items.length - 1 }"
        :aria-current="index === items.length - 1 ? 'page' : null"
      >
        <router-link v-if="index < items.length - 1" :to="item.path">{{
          item.name
        }}</router-link>
        <span v-else>{{ item.name }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
/**
 * 内页面包屑。最后一项是当前页，不做成链接。
 */
export default {
  name: "PageBreadcrumb",
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>
